import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function CarFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [vehicleType, setVehicleType] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedCar, setSelectedCar] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setSelectedCar(null);
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
    setSelectedCar(null);
  };

  const vehicleTypes = [
    { id: "all", name: "Todos" },
    { id: "sedan", name: "Sedan" },
    { id: "suv", name: "SUV" },
    { id: "hatch", name: "Hatch" },
    { id: "pickup", name: "Picape" },
    { id: "sports", name: "Esportivo" },
    { id: "motorcycle", name: "Moto" },
    { id: "truck", name: "Caminhão" },
  ];

  const fuelTypes = {
    flex: "Flex",
    gasoline: "Gasolina",
    ethanol: "Etanol",
    diesel: "Diesel",
    electric: "Elétrico",
    hybrid: "Híbrido",
  };

  const transmissions = {
    manual: "Manual",
    automatic: "Automático",
    cvt: "CVT",
  };

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/car?page=${pageNum}&limit=12`;
      if (vehicleType !== "all") url += `&vehicleType=${vehicleType}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching car:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [vehicleType]);

  if (loading && posts.length === 0) {
    return <div className="car_feed_loading"><div className="car_loader"></div><span>Carregando veículos...</span></div>;
  }

  return (
    <div className="car_feed">
      {vehicleTypes.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {vehicleTypes.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${vehicleType === filter.id ? "active" : ""}`}
                onClick={() => setVehicleType(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="car_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
          </svg>
          <h3>Nenhum veículo encontrado</h3>
          <p>Anuncie o seu!</p>
        </div>
      ) : (
        <div className="car_grid">
          {posts.map((post) => (
            <div key={post._id} className="car_card" onClick={() => setSelectedCar(post)}>
              <div className="car_image">
                <img src={post.carData?.photos?.[0] || post.images?.[0]?.url || post.images?.[0] || "/images/default-car.png"} alt="" />
                {post.carData?.featured && (
                  <span className="car_featured_badge">Destaque</span>
                )}
                <span className="car_condition_badge">
                  {post.carData?.condition === "new" ? "0km" : "Usado"}
                </span>
              </div>
              <div className="car_card_content">
                <div className="car_make_model">
                  <h3>{post.carData?.make} {post.carData?.model}</h3>
                  <span className="car_year">{post.carData?.year}</span>
                </div>
                <p className="car_version">{post.carData?.version}</p>
                <div className="car_specs">
                  <span>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M12 16c1.01 0 1.91-.39 2.62-1H9.38c.71.61 1.61 1 2.62 1zm-3-4.5V10c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1.5h1V9c0-.55-.45-1-1-1H11V6.11c-.53-.23-1-.53-1.38-.91l-2.17 2.17c-.12.12-.21.26-.27.42L6 11.3V9H5v4h2V8.67l.77-.77.71 2.13-.77.77-.29-.88-.42-.42V13h5.7l2.3 2.3v1.92l-2.87 2.87C12 20.07 12 20.03 12 20c0-.55-.45-1-1-1s-1 .45-1 1-.45 1-1 1h-.5c-.28 0-.5.22-.5.5s.22.5.5.5H10c.59 0 1.09-.21 1.5-.55.41.34.91.55 1.5.55h.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H13c-.55 0-1-.45-1-1 0-.03 0-.07-.01-.1l3.01-3.01V13h-6z"/>
                    </svg>
                    {(post.carData?.mileage || 0).toLocaleString("pt-BR")} km
                  </span>
                  <span>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
                    </svg>
                    {fuelTypes[post.carData?.fuelType] || "Flex"}
                  </span>
                  <span>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
                    </svg>
                    {transmissions[post.carData?.transmission] || "Manual"}
                  </span>
                </div>
                <div className="car_footer">
                  <span className="car_price">
                    R$ {(post.carData?.price || 0).toLocaleString("pt-BR")}
                  </span>
                  <span className="car_location">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="12" height="12">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                    </svg>
                    {post.carData?.location || "Brasil"}
                  </span>
                  <div onClick={(e) => e.stopPropagation()}>
                    <FeedPostMenu
                      post={post}
                      onEdit={handleEditPost}
                      onPostDeleted={handlePostDeleted}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="car_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais veículos"}
          </button>
        </div>
      )}

      {selectedCar && (
        <div className="car_modal_overlay" onClick={() => setSelectedCar(null)}>
          <div className="car_modal" onClick={(e) => e.stopPropagation()}>
            <button className="car_modal_close" onClick={() => setSelectedCar(null)}>✕</button>

            <div className="car_modal_gallery">
              <img src={selectedCar.carData?.photos?.[0] || selectedCar.images?.[0]} alt="" />
              {selectedCar.carData?.photos?.length > 1 && (
                <div className="car_gallery_thumbs">
                  {selectedCar.carData.photos.slice(1, 5).map((photo, i) => (
                    <img key={i} src={photo} alt="" />
                  ))}
                </div>
              )}
            </div>

            <div className="car_modal_body">
              <div className="car_modal_header">
                <div>
                  <h2>{selectedCar.carData?.make} {selectedCar.carData?.model}</h2>
                  <span className="car_modal_version">{selectedCar.carData?.version} • {selectedCar.carData?.year}</span>
                </div>
                <div className="car_modal_price">
                  R$ {(selectedCar.carData?.price || 0).toLocaleString("pt-BR")}
                </div>
              </div>

              <div className="car_modal_specs">
                <div className="car_spec_item">
                  <span className="car_spec_label">Quilometragem</span>
                  <span className="car_spec_value">{(selectedCar.carData?.mileage || 0).toLocaleString("pt-BR")} km</span>
                </div>
                <div className="car_spec_item">
                  <span className="car_spec_label">Combustível</span>
                  <span className="car_spec_value">{fuelTypes[selectedCar.carData?.fuelType] || "Flex"}</span>
                </div>
                <div className="car_spec_item">
                  <span className="car_spec_label">Câmbio</span>
                  <span className="car_spec_value">{transmissions[selectedCar.carData?.transmission] || "Manual"}</span>
                </div>
                <div className="car_spec_item">
                  <span className="car_spec_label">Cor</span>
                  <span className="car_spec_value">{selectedCar.carData?.color || "Não informado"}</span>
                </div>
                <div className="car_spec_item">
                  <span className="car_spec_label">Portas</span>
                  <span className="car_spec_value">{selectedCar.carData?.doors || 4}</span>
                </div>
                <div className="car_spec_item">
                  <span className="car_spec_label">Condição</span>
                  <span className="car_spec_value">{selectedCar.carData?.condition === "new" ? "Novo" : "Usado"}</span>
                </div>
              </div>

              {selectedCar.carData?.features?.length > 0 && (
                <div className="car_modal_features">
                  <h4>Características</h4>
                  <div className="car_features_grid">
                    {selectedCar.carData.features.map((feature, i) => (
                      <span key={i}>
                        <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                        </svg>
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {(selectedCar.carData?.description || selectedCar.text) && (
                <div className="car_modal_desc_section">
                  <h4>Descrição</h4>
                  <p>{selectedCar.carData?.description || selectedCar.text}</p>
                </div>
              )}

              <Link to={`/profile/${selectedCar.user.username}`} className="car_seller">
                <img src={selectedCar.user.picture} alt="" />
                <div>
                  <span className="car_seller_label">Vendedor</span>
                  <span className="car_seller_name">{selectedCar.user.first_name} {selectedCar.user.last_name}</span>
                </div>
              </Link>

              <div className="car_modal_actions">
                {selectedCar.carData?.phone && (
                  <a href={`tel:${selectedCar.carData.phone}`} className="car_call_btn">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                    </svg>
                    Ligar
                  </a>
                )}
                {selectedCar.carData?.whatsapp && (
                  <a href={`https://wa.me/${selectedCar.carData.whatsapp}`} target="_blank" rel="noreferrer" className="car_whatsapp_btn">
                    WhatsApp
                  </a>
                )}
                <button className="car_interest_btn">Tenho interesse</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
